export default function AvailabilityField({ visibleFields, value, onChange, showValidation }) {
  const field = visibleFields.find((f) => f.id === "availability");
  if (!field) return null;
  
  const isMandatory = field.mandatory === true;
  const isEmpty = !value || value.trim() === "";
  const showError = showValidation && isMandatory && isEmpty;
  
  return (
    <div className="flex flex-col">
      <label htmlFor={field.id} className="input-label">
        {field.label} {isMandatory && "*"}
      </label>
      <input
        type="date"
        id={field.id}
        name={field.id}
        value={value ? new Date(value).toISOString().split("T")[0] : ""}
        onChange={onChange}
        className={`input ${showError ? "border-red-500" : ""}`}
      />
    </div>
  );
}


